export enum PICEvents {
  LoadedModule = 'PicModuleLoaded'
}
//TODO move all events' name to Events